import offerStatusTypes from "../modules/Offers/enums/offerStatusTypes";

export default {
    getPendingValue() {
        return offerStatusTypes.find(el => el.name === 'PENDING').value
    },
    getAcceptedValue() {
        return offerStatusTypes.find(el => el.name === 'ACCEPTED').value
    },
    getDeclinedValue() {
        return offerStatusTypes.find(el => el.name === 'DECLINED').value
    }
}